module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1167.7c7e4392.png";